module.exports = __webpack_public_path__ + "img/banjo.c6f8a325.svg";